package de.emgress.baskets.core.extensions

import core.enums.EEnvironmentVariables
import kotlinx.browser.window

fun EEnvironmentVariables.getValue(): String {
    return window.asDynamic()[mVariableName] as String
}

/*fun EEnvironmentVariables.getValueOrDefault(): String {
    return window.asDynamic()[mVariableName] as? String ?: mDefault
}*/